import SideBar from "./SideBar/SideBar";
import TopBar from "./TopBar/TopBar";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { fetchUserLastLogin } from "../pages/Home/store-utils";

export const Layout = () => {
  useEffect(() => {
    fetchUserLastLogin();
  }, []);
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  return (
    <div className="flex font-primary">
      <div>
        <SideBar isSideBarOpen={isSideBarOpen} />
      </div>
      <div className="w-full bg-[#F9FAFB]">
        <TopBar setIsSideBarOpen={setIsSideBarOpen} />
        <Outlet />
      </div>
    </div>
  );
};
